import Papa from 'papaparse';

// downloadCSV start api
export const generateFilename = (): string => {
  const chars = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';
  let randomString = '';
  for (let i = 0; i < 10; i++) {
    randomString += chars.charAt(Math.floor(Math.random() * chars.length));
  }
  return `data_${randomString}.csv`;
};

export const downloadCSV = (filename: string, data: any[]) => {
  const copyUserData = data ? [...data] : [];

  const formatDate = (modifiedData: string) => {
    const date = new Date(modifiedData);
    const year = date.getFullYear();
    const month = String(date.getMonth() + 1).padStart(2, '0');
    const day = String(date.getDate()).padStart(2, '0');
    return `${year}-${month}-${day}`;
  };

  const capitalizeFirstLetter = (str: string) => {
    return str.charAt(0).toUpperCase() + str.slice(1);
  };

  const capitalizeHeaders = (header: string) => {
    // Capitalize each word in the header
    const words = header.split(/(?=[A-Z])/).map(capitalizeFirstLetter);
    // Replace "FirstName" with "First Name"
    return words.join(' ').replace('FirstName', 'First Name');
  };

  // Modify headers
  const modifiedHeaders = Object.keys(copyUserData[0]).map(capitalizeHeaders);
  console.log('Modified Headers:', modifiedHeaders);

  // Modify data objects to match modified headers
  const modifiedData = copyUserData.map((obj: any) => {
    const newObj: any = {};
    for (const key in obj) {
      if (
        Object.prototype.hasOwnProperty.call(obj, key) &&
        key !== 'id' &&
        key !== 'enrolledDegrees'
      ) {
        const modifiedKey = capitalizeHeaders(key);
        // console.log('modifiedKey',modifiedKey,'key',key);

        if (key == 'createdAt') {
          newObj['Signup Date'] = obj[key];
        } else if (key == 'studyType') {
          newObj['PT/FT Status'] = obj[key];
        } else if (key == 'studentEnrolledType') {
          newObj['Status'] = obj[key];
        } else if (key == 'enrolledDegreesNames') {
          newObj['Enrolled Degrees'] = obj[key];
        } else if (key == 'enrolledCoursesCount') {
          newObj['Enrolled Courses'] = obj[key];
        } else if (key == 'passedCoursesCount') {
          newObj['Passed Courses'] = obj[key];
        } else if (key == 'completedObjectivesCount') {
          newObj['Completed Objectives'] = obj[key];
        } else {
          newObj[modifiedKey] = obj[key];
        }
      } else {
        if (obj[key]?.enrolledDegrees && obj[key]?.enrolledDegrees.length > 0) {
          newObj['Enrolled Degrees'] = obj[key].enrolledDegrees
            .map((degree: any, index: number) => `${index + 1}. ${degree.degree.name}`)
            .join('\n');
        }
      }
    }

    // Always define the column so it survives even when the first row has no
    // degrees. Papa.unparse derives headers from the first object's keys, so a
    // conditionally-set field disappears for the whole file when row 0 lacks it.
    if (!newObj.hasOwnProperty('Enrolled Degrees')) {
      newObj['Enrolled Degrees'] = '';
    }
    newObj['Last Active'] = formatDate(newObj['Last Active']);
    newObj['Signup Date'] = formatDate(newObj['Signup Date']);

    // Capitalize subscription values
    newObj['Subscription Type'] = newObj['Subscription Type']
      ? capitalizeFirstLetter(newObj['Subscription Type'].toLowerCase())
      : '';
    newObj['Subscription Status'] = newObj['Subscription Status']
      ? capitalizeFirstLetter(newObj['Subscription Status'].toLowerCase().replace(/_/g, ' '))
      : '';
    newObj['Status'] = newObj['Status']
      ? capitalizeFirstLetter(newObj['Status'].toLowerCase())
      : '';
    newObj['Student Paying Type'] = newObj['Student Paying Type']
      ? capitalizeFirstLetter(newObj['Student Paying Type'].toLowerCase().replace(/_/g, ' '))
      : '';
    newObj['PT/FT Status'] = newObj['PT/FT Status']
      ? capitalizeFirstLetter(newObj['PT/FT Status'].toLowerCase().replace(/_/g, ' '))
      : '';

    const keyOrder = [
      'Student Id',
      'First Name',
      'Last Name',
      'Email',
      'Subscription Status',
      'Status',
      'Subscription Type',
      'Enrolled Degrees',
      'PT/FT Status',
      'Enrolled Courses',
      'Passed Courses',
      'Completed Objectives',
      'Last Active',
      'Signup Date',
    ];

    const reorderedObj: any = {};
    keyOrder.forEach((key) => {
      if (newObj.hasOwnProperty(key)) {
        reorderedObj[key] = newObj[key];
      }
    });
    return reorderedObj;
    //return newObj;
  });
  // Now, use Papa.unparse without specifying fields option
  const csv = modifiedData.length > 0 ? Papa.unparse(modifiedData) : '';
  const blob = new Blob([csv], { type: 'text/csv;charset=utf-8;' });
  const url = URL.createObjectURL(blob);
  const link = document.createElement('a');
  link.setAttribute('href', url);
  link.setAttribute('download', filename);
  link.click();
};

export const downloadComprehensiveJSON = (filename: string, data: any[]) => {
  console.log('Raw API response data:', data);

  if (!data || data.length === 0) {
    console.error('No data received for comprehensive export');
    alert('No data available to export');
    return;
  }

  // The data should already be in the correct format from the API
  const copyUserData = [...data];
  console.log('Comprehensive JSON data:', copyUserData);

  // Generate JSON file
  const jsonData = JSON.stringify(copyUserData, null, 2);
  const blob = new Blob([jsonData], { type: 'application/json;charset=utf-8;' });
  const url = URL.createObjectURL(blob);
  const link = document.createElement('a');
  link.setAttribute('href', url);
  link.setAttribute('download', filename);
  link.click();

  // Clean up the URL object
  URL.revokeObjectURL(url);
};
